import { combineReducers } from 'redux';
import {
  activeGroupId,
  unifiedCompareData,
  userAction,
  userActionLoading,
  loading,
  errors,
  validationError,
} from './reducers';

export const productsCompare = combineReducers({
  activeGroupId,
  data: unifiedCompareData,
  userAction,
  userActionLoading,
  loading,
  errors,
  validationError,
});
